import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row py-3 bt-dash" }
const _hoisted_2 = { class: "col-sm-9 d-flex justify-content-center" }
const _hoisted_3 = { style: {"aspect-ratio":"1 / 1","width":"25%"} }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "img-thumbnail w-100 h-100 d-flex align-items-center justify-content-center",
  style: {"background-color":"#f0f0f0"}
}
const _hoisted_6 = { class: "col-sm-3 d-flex align-items-center" }
const _hoisted_7 = { class: "mb-3 w-100" }
const _hoisted_8 = {
  key: 1,
  style: {"height":"35px"}
}
const _hoisted_9 = { class: "row py-3 bt-dash" }
const _hoisted_10 = { class: "col-sm-9" }
const _hoisted_11 = {
  class: "color-list-container mt-3",
  style: {"min-height":"320px"}
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "text-white" }
const _hoisted_14 = { class: "col-sm-3 d-flex flex-column" }
const _hoisted_15 = { class: "d-flex flex-column justify-content-between w-100 flex-grow-1" }

import { ref, reactive, onMounted, computed, watch } from 'vue';
import { useProductGroupsStore } from '@/store/management/productGroupsStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'productGroupsAppearance',
  setup(__props) {

const productGroupsStore = useProductGroupsStore();

const compState = reactive({
    imageUrl: '',
    buttonSize: '',
    activeColor: '',
});

const fileInput = ref<HTMLInputElement | null>(null);


const colorList = ref([
    { id: '1', name: 'Red', color: '#FF0000' },
    { id: '2', name: 'Green', color: '#00aa00' },
    { id: '3', name: 'Blue', color: '#0000FF' },
    { id: '4', name: 'Yellow', color: '#FFFF00' },
    { id: '5', name: 'Cyan', color: '#00FFFF' },
    { id: '6', name: 'Magenta', color: '#FF00FF' },
    { id: '7', name: 'Orange', color: '#FFA500' },
    { id: '8', name: 'Purple', color: '#800080' },
    { id: '9', name: 'Brown', color: '#A52A2A' },
    { id: '10', name: 'Pink', color: '#FFC0CB' },
    { id: '11', name: 'Lime', color: '#32cd32' },
    { id: '12', name: 'Teal', color: '#008080' },
]);

const activeProductGroup = computed(() => {
    return productGroupsStore.getActiveProductGroup
})

const tempActiveProductGroup = computed(() => {
    return productGroupsStore.getTempActiveProductGroup
})

const activeProductGroupId = computed(() => {
    return productGroupsStore.getActiveProductGroupId
})

onMounted(() => {
    if (tempActiveProductGroup.value?.id) {
        compState.imageUrl = tempActiveProductGroup.value?.appearance?.image || '';
        compState.buttonSize = tempActiveProductGroup.value?.appearance?.fontSizes || '';
        compState.activeColor = tempActiveProductGroup.value?.appearance?.buttonColor || '';
    }
    console.log('tempActiveDepartment', tempActiveProductGroup.value);

});

watch(activeProductGroupId, (newVal) => {
    if (newVal) {
        const department = activeProductGroup.value
        compState.imageUrl = department.appearance.image;
        compState.buttonSize = department.appearance.fontSizes;
        compState.activeColor = department.appearance.buttonColor;
        if (fileInput.value) {
            fileInput.value.value = '';
        }
    }
});

watch(compState, (newVal) => {
    productGroupsStore.setTempActiveProductGroup({
        ...tempActiveProductGroup.value,
        appearance: {
            image: compState.imageUrl,
            buttonColor: compState.activeColor,
            fontSizes: compState.buttonSize,
        }
    });
}, { deep: true });

function previewImage(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
        compState.imageUrl = URL.createObjectURL(file);
    }
}

function removeImage() {
    compState.imageUrl = '';
    if (fileInput.value) {
        fileInput.value.value = '';
    }
}
function setFontSize(size: string) {
    compState.buttonSize = size;
}
function onColorClick(id: string) {
    compState.activeColor = id;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (compState.imageUrl)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: compState.imageUrl,
                alt: "Image Preview",
                class: "img-thumbnail w-100 h-100 object-fit-cover"
              }, null, 8, _hoisted_4))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[4] || (_cache[4] = [
                _createElementVNode("span", null, "No Image", -1)
              ])))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[5] || (_cache[5] = _createElementVNode("label", {
            for: "image-upload",
            class: "form-label"
          }, "Upload Image", -1)),
          _createElementVNode("input", {
            class: "form-control mb-3",
            type: "file",
            id: "image-upload",
            onChange: previewImage,
            ref_key: "fileInput",
            ref: fileInput
          }, null, 544),
          (compState.imageUrl)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-danger w-100",
                onClick: removeImage
              }, "Remove Image"))
            : (_openBlock(), _createElementBlock("div", _hoisted_8))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _cache[6] || (_cache[6] = _createElementVNode("h6", { class: "f-w-700" }, "Button Color", -1)),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colorList.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "text-center py-2 rounded-3 hover-pointer card mb-0 d-flex flex-column justify-content-center align-items-center",
              style: _normalizeStyle([{"height":"96px"}, {
                        backgroundColor: item.color, gridColumn: 'span 1 / span 1',
                        boxShadow: compState.activeColor === item.id ? 'inset 0 0 16px rgba(0, 0, 0, 0.7)' : 'none'
                    }]),
              onClick: ($event: any) => (onColorClick(item.id)),
              key: item.id
            }, [
              _createElementVNode("h5", _hoisted_13, _toDisplayString(item.name), 1)
            ], 12, _hoisted_12))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _cache[7] || (_cache[7] = _createElementVNode("h6", { class: "f-w-700 mb-3" }, "Button Font Size", -1)),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn btn-outline-primary w-100 py-3", { ' btn-primary': compState.buttonSize === 'X-Large' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setFontSize('X-Large'))),
            style: {"font-size":"1.5rem"}
          }, "X-Large", 2),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn btn-outline-primary w-100 py-3", { ' btn-primary': compState.buttonSize === 'Large' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (setFontSize('Large'))),
            style: {"font-size":"1.25rem"}
          }, "Large", 2),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn btn-outline-primary w-100 py-3", { ' btn-primary': compState.buttonSize === 'Medium' }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (setFontSize('Medium'))),
            style: {"font-size":"1rem"}
          }, "Medium", 2),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn btn-outline-primary w-100 py-3", { ' btn-primary': compState.buttonSize === 'Small' }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (setFontSize('Small'))),
            style: {"font-size":"0.875rem"}
          }, "Small", 2)
        ])
      ])
    ])
  ], 64))
}
}

})